import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import './index.css';
import './tailwind.css';
import App from './app';

// HashRouter doesn't need a basename as it uses the hash part of the URL
console.log('Application initializing');
console.log('PUBLIC_URL:', process.env.PUBLIC_URL);
console.log('Current location:', window.location.href);

// HashRouter is better for GitHub Pages as it uses URL hash which doesn't require server-side support
// Important: HashRouter should NOT have a basename as it works differently than BrowserRouter
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);